import axiosInstance from "@/api/axios-instance";

export interface ChangeBundlePricePayload {
  mode: "SET" | "INCREASE" | "DECREASE";
  valueType?: "AMOUNT" | "PERCENT";
  value: number;
  // The new version's per-session price; omitted → the current one carries over.
  single_session_amount?: number;
}

// Retires the offering's current active bundle and creates a new active one
// with the new amount (the old price becomes history).
export async function changeBundlePrice(
  id: string,
  payload: ChangeBundlePricePayload,
) {
  return (await axiosInstance.post(`/bundle/${id}/price-change`, payload)).data;
}

export interface BulkPriceChangeItem {
  id: string; // the offering's current active bundle id
  amount: number; // final amount for it
}

// Apply a final amount to many offerings at once (each row's edited price).
export async function changeBundlePricesBulk(changes: BulkPriceChangeItem[]) {
  return (await axiosInstance.post(`/bundle/price-change/bulk`, { changes }))
    .data;
}
